(ns ballot-scout-v2-frontend.views
  (:require
   [ballot-scout-v2-frontend.auth :as auth]
   [ballot-scout-v2-frontend.components.link :refer [link]]
   [ballot-scout-v2-frontend.layout.page-content :refer [landing-page logging-in-page page-content]]
   [ballot-scout-v2-frontend.subs :as subs]
   ;; TODO: Ensure Google Analytics script timing works with 
   ;; our title updates before uncommenting below.
   ;; [ballot-scout-v2-frontend.components.title :as title]
   [re-frame.core :as rf]))

(defn full-pager [text]
  [:section {:class "hero is-white is-fullheight"}
   [:div {:class "hero-body"}
    [:div {:class "container"}
     [:h1 {:class "title"} text]]]])

(defn dashboard-redirect []
  (let [user @(rf/subscribe [::subs/user])
        default-partner-id (-> user :profile :partner-id)
        default-partner @(rf/subscribe [::subs/partner-by-id default-partner-id])
        default-partner-slug (:partner/slug default-partner)
        default-juri-id (-> user :profile :jurisdiction-ids first)
        default-jurisdiction @(rf/subscribe [::subs/jurisdiction-by-id default-juri-id])
        default-jurisdiction-slug (:jurisdiction/slug default-jurisdiction)
        all-elections @(rf/subscribe [::subs/elections-for-jurisdiction default-jurisdiction-slug])
        default-election (or (-> default-jurisdiction :jurisdiction/current-election)
                             (first all-elections))
        default-election-slug (:election/slug default-election)]
    (cond
      (and default-partner-slug default-jurisdiction-slug default-election-slug)
      (if (auth/partner-admin? (:profile user))
        (rf/dispatch [:ballot-scout-v2-frontend.routes/redirect
                      :ballot-scout-v2-frontend.routes/partner-home
                      {:partner-slug default-partner-slug
                       :election-slug default-election-slug}])
        (rf/dispatch [:ballot-scout-v2-frontend.routes/redirect
                      :ballot-scout-v2-frontend.routes/jurisdiction-home
                      {:partner-slug default-partner-slug
                       :jurisdiction-slug default-jurisdiction-slug
                       :election-slug default-election-slug}]))

      (and default-partner-slug default-jurisdiction-slug)
      ;; TODO: allow user to switch away from jurisdiction with no elections
      [full-pager "This jurisdiction has no elections"]

      default-partner-slug
      [full-pager "Please create a jurisdiction under this partner"]

      :else
      [logging-in-page])))

(defn front-page []
  (let [page-ready? (rf/subscribe [::subs/index-page-ready?])
        logged-in? (rf/subscribe [::auth/logged-in?])]
    (when @page-ready?
      (if @logged-in?
        [dashboard-redirect]
        (rf/dispatch [:ballot-scout-v2-frontend.routes/redirect
                      :ballot-scout-v2-frontend.routes/login])))))

(defn login-failure-page [{:keys [statusCode description]}]
  [:<>
   [:div "There was an error when fetching your user data"]
   (when statusCode [:div statusCode])
   (when description [:div description])
   [:div [link :ballot-scout-v2-frontend.routes/login
          "Click here to login"]]])

(defn not-ready-view []
  (if-let [profile-retrieval-error @(rf/subscribe [::subs/auth0-retrieve-profile-error])]
    [login-failure-page profile-retrieval-error]
    [logging-in-page]))

(defn page-404 []
  [full-pager "404"])

(defn header []
  [:div
   [link :ballot-scout-v2-frontend.routes/index "Home"]
   " - "
   (if @(rf/subscribe [::auth/logged-in?])
     [link :ballot-scout-v2-frontend.routes/logout "Log Out"]
     [link :ballot-scout-v2-frontend.routes/login "Log In"])
   [:hr]])

(defn authentication-failure-view []
  [landing-page
   [:div "Ballot Scout could not log you in. Please ensure that you have cookies enabled and that you are not viewing this site in private mode or incognito mode."]])

(defn main-panel []
  (let [current-route (rf/subscribe [:ballot-scout-v2-frontend.routes/current-route])
        auth0-status (rf/subscribe [::subs/auth0-status])]
    (fn []
      [:div {:class "main"}
       ;; TODO: Ensure Google Analytics script timing works with 
       ;; our title updates before uncommenting below.
      ;  [title/title-updater]
       (cond (= :404 @current-route)
             [page-404]

             (= @auth0-status :fetching)
             [not-ready-view]

             ;; if the route is not public and we can't instantiate an auth0-client
             ;; we return an auth failure page
             (and (not (get-in @current-route [:data :public?]))
                  (nil? auth/auth0-client))
             [authentication-failure-view]

             (and @(rf/subscribe [::subs/on-partner-admin-page?])
                  (not @(rf/subscribe [::subs/can-view-partner-admin-pages?])))
             [page-404]

             (get-in @current-route [:data :container?])
             (when-let [current-view (get-in @current-route [:data :view])]
               [page-content
                [current-view]])

             :else
             (when-let [current-view (get-in @current-route [:data :view])]
               [current-view]))])))
